import EvaluationFlow from "../../../../flow/EvaluationFlow"
import {
  EligibleInAppMessageEligibilityFlowEvaluator,
  FrequencyInAppMessageEligibilityFlowEvaluator,
  HiddenInAppMessageEligibilityFlowEvaluator,
  PeriodInAppMessageEligibilityFlowEvaluator,
  PlatformInAppMessageEligibilityFlowEvaluator,
  TimetableInAppMessageEligibilityFlowEvaluator
} from "./InAppMessageEligibilityFlowEvaluator"
import {
  InAppMessageEligibilityRemoteFlow,
  IneligibleInAppMessageEligibilityRemoteFlowEvaluator,
  LayoutResolveInAppMessageEligibilityRemoteFlowEvaluator,
  OverrideInAppMessageEligibilityRemoteFlowEvaluator
} from "./InAppMessageEligibilityRemoteFlowEvaluator"
import { InAppMessageEligibilityEvaluateResult } from "../InAppMessageEligibilityEvaluateResult"
import { InAppMessageEligibilityRemoteEvaluateRequest } from "../mode/remote/InAppMessageEligibilityRemoteEvaluateRequest"
import { InAppMessageEligibilityFlowFactory } from "./InAppMessageEligibilityFlowFactory"
import InAppMessageHiddenStorage from "../match/InAppMessageHiddenStorage"
import { InAppMessageImpressionStorage } from "../match/InAppMessageImpressionStorage"
import { HiddenInAppMessageMatcher, InAppMessageFrequencyCapMatcher } from "../match/InAppMessageMatcher"
import { InAppMessageLayoutRemoteEvaluator } from "../../layout/mode/remote/InAppMessageLayoutRemoteEvaluator"

export default class InAppMessageEligibilityRemoteEvaluationFlowFactory
  implements InAppMessageEligibilityFlowFactory<InAppMessageEligibilityRemoteEvaluateRequest>
{
  private readonly triggerFlow: InAppMessageEligibilityRemoteFlow
  private readonly deliverFlow: InAppMessageEligibilityRemoteFlow
  private readonly deliverReEvaluateFlow: InAppMessageEligibilityRemoteFlow

  constructor(
    inAppMessageImpressionStorage: InAppMessageImpressionStorage,
    inAppMessageHiddenStorage: InAppMessageHiddenStorage,
    layoutEvaluator: InAppMessageLayoutRemoteEvaluator
  ) {
    const overrideFlow = [new OverrideInAppMessageEligibilityRemoteFlowEvaluator()]

    const evaluationFlow = [
      new PlatformInAppMessageEligibilityFlowEvaluator<InAppMessageEligibilityRemoteEvaluateRequest>(),
      new OverrideInAppMessageEligibilityRemoteFlowEvaluator(),
      new IneligibleInAppMessageEligibilityRemoteFlowEvaluator(),
      new PeriodInAppMessageEligibilityFlowEvaluator<InAppMessageEligibilityRemoteEvaluateRequest>(),
      new TimetableInAppMessageEligibilityFlowEvaluator<InAppMessageEligibilityRemoteEvaluateRequest>()
    ]

    const layoutFlow = [new LayoutResolveInAppMessageEligibilityRemoteFlowEvaluator(layoutEvaluator)]

    const deduplicateFlow = [
      new FrequencyInAppMessageEligibilityFlowEvaluator<InAppMessageEligibilityRemoteEvaluateRequest>(
        new InAppMessageFrequencyCapMatcher(inAppMessageImpressionStorage)
      ),
      new HiddenInAppMessageEligibilityFlowEvaluator<InAppMessageEligibilityRemoteEvaluateRequest>(
        new HiddenInAppMessageMatcher(inAppMessageHiddenStorage)
      )
    ]

    const eligibleFlow = [
      new EligibleInAppMessageEligibilityFlowEvaluator<InAppMessageEligibilityRemoteEvaluateRequest>()
    ]

    this.triggerFlow = EvaluationFlow.of<
      InAppMessageEligibilityRemoteEvaluateRequest,
      InAppMessageEligibilityEvaluateResult
    >(...evaluationFlow, ...layoutFlow, ...deduplicateFlow, ...eligibleFlow)

    this.deliverFlow = EvaluationFlow.of<
      InAppMessageEligibilityRemoteEvaluateRequest,
      InAppMessageEligibilityEvaluateResult
    >(...overrideFlow, ...deduplicateFlow, ...eligibleFlow)

    this.deliverReEvaluateFlow = EvaluationFlow.of<
      InAppMessageEligibilityRemoteEvaluateRequest,
      InAppMessageEligibilityEvaluateResult
    >(...evaluationFlow, ...deduplicateFlow, ...eligibleFlow)
  }

  get(request: InAppMessageEligibilityRemoteEvaluateRequest): InAppMessageEligibilityRemoteFlow {
    switch (request.scope) {
      case "TRIGGER":
        return this.triggerFlow
      case "DELIVER":
        return request.inAppMessage.evaluateContext.atDeliverTime ? this.deliverReEvaluateFlow : this.deliverFlow
      default:
        throw new Error(`Unsupported scope [${request.scope}]`)
    }
  }
}
